import React from 'react';
import {TransitionablePortal} from 'semantic-ui-react';

interface ErrorPortalProps {
  children?: React.ReactNode;
  open: boolean;
}

const ErrorPortal: React.FC<ErrorPortalProps> = ({open, children}) => {
  return (
    <TransitionablePortal
      open={open}
      closeOnDocumentClick={false}
      closeOnEscape={false}>
      <div className="error-portal">
        <div className="error-portal-content">{children}</div>
      </div>
    </TransitionablePortal>
  );
};

export default ErrorPortal;
